import React from "react";
import { ReactComponent as VisaIcon } from "../assets/PaymentMethods/Visa.svg";
import { ReactComponent as MasterCardIcon } from "../assets/PaymentMethods/MasterCard.svg";
import { ReactComponent as MaestroIcon } from "../assets/PaymentMethods/Maestro.svg";
import { ReactComponent as UnionPayIcon } from "../assets/PaymentMethods/UnionPay.svg";
import { ReactComponent as TwintIcon } from "../assets/PaymentMethods/Twint.svg";
import { ReactComponent as SixIcon } from "../assets/PaymentMethods/Six.svg";
import { ReactComponent as DinnerClubIcon } from "../assets/PaymentMethods/dinner-club.svg";
import { ReactComponent as BankTransferIcon } from "../assets/PaymentMethods/bank-transfer.svg";

const BottomInfoSection = () => {
  const cigarBrands = Array.from(
    { length: 28 },
    (_, i) => `/img/brand-${i + 1}.jpg`
  );

  const paymentIcons = [
    { name: "Visa", Component: VisaIcon },
    { name: "MasterCard", Component: MasterCardIcon },
    { name: "Maestro", Component: MaestroIcon },
    { name: "UnionPay", Component: UnionPayIcon },
    { name: "Twint", Component: TwintIcon },
    { name: "Six", Component: SixIcon },
    { name: "DinnerClub", Component: DinnerClubIcon },
    { name: "BankTransfer", Component: BankTransferIcon },
  ];

  return (
    <div
      className="info-section"
      style={{
        paddingBottom: "1rem", // Relative padding
      }}
    >
      <img
        src="/img/bottom-info-image.jpeg"
        alt="garturbo cigar brand"
        style={{
          width: "95%", // Auto scales to fit screen width
          height: "auto", // Maintains aspect ratio
          maxWidth: "1200px", // Optional: Set a max width for larger screens
          display: "block",
          margin: "0 auto", // Centers the image
          paddingTop: "1rem",
        }}
      />

      {/* New Cigar Brands Section */}
      <div
        style={{
          marginTop: "2rem",
          marginLeft: "2rem",
          marginRight: "2rem",
          textAlign: "left",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap", // Wrap items for responsive layout
            justifyContent: "center",
            gap: "0.5rem", // Add spacing between items
          }}
        >
          {cigarBrands.map((brand, index) => (
            <img
              key={index}
              src={brand}
              alt={`Cigar Brand ${index + 1}`}
              style={{
                width: "12%", // Image size
                height: "auto", // Maintain aspect ratio
                borderRadius: "0.5rem",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            />
          ))}
        </div>

        {/* Footer Info and Payment Section */}
        <div
          style={{
            backgroundColor: "#2c3e50",
            color: "#fff",
            padding: "2rem 1rem",
            margin: "2rem -2rem 0",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "0rem",
            }}
          >
            {/* Text Section */}
            <div style={{ textAlign: "left", width: "100%" }}>
              <h5 style={{ marginBottom: "0.5rem" }}>茄多堡（香港）</h5>
              <div
                style={{
                  width: "30px",
                  height: "3px",
                  backgroundColor: "#ccc",
                  marginBottom: "1rem",
                }}
              />
              <p>地址：彌敦道575號駿盈中心15樓</p>
              <p>Whatsapp：+65 80135563</p>
              <p>郵箱：garturbo2024@icloud.com</p>
            </div>

            {/* Lounge Image */}
            <div
              style={{
                width: "100%",
                maxWidth: "600px",
              }}
            >
              <img
                src="/img/lounge.jpg"
                alt="Garturbo Lounge"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "0.5rem",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div
            style={{
              backgroundColor: "#293949",
              padding: "2rem 1rem",
              marginTop: "2rem",
              marginLeft: "-1rem",
              marginRight: "-1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "1rem",
                maxWidth: "1200px",
                margin: "0 auto",
              }}
            >
              {paymentIcons.map(({ name, Component }) => (
                <div
                  key={name}
                  style={{
                    backgroundColor: "#334352",
                    padding: "0.5rem",
                    borderRadius: "0.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Component
                    style={{
                      width: "50px",
                      height: "auto",
                      maxHeight: "30px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomInfoSection;
